import { useFlags } from "launchdarkly-react-client-sdk";
import { useDefinitionsTabEnabled } from "src/pages/context-hub/definitions/use-definitions-tab-enabled";

export function useSessionContextPanelEnabled(): boolean {
  const { agentDefinitionsContextPanel } = useFlags();
  const isDefinitionsTabEnabled = useDefinitionsTabEnabled();
  return Boolean(agentDefinitionsContextPanel) && isDefinitionsTabEnabled;
}
